export const generateKeyForComponent = c =>
  (c.displayName || c.name) + Math.floor(Math.random() * (1 << 30)).toString(16)
